<script>
    import InformaContctUs from "$lib/sections/InformaContactUs.svelte";
    import SectionWrappers from "$lib/components/SectionWrapper.svelte";
    import {onDestroy, onMount} from "svelte";
    import decodeHtmlEntities from "$lib/helpers/decodeHtmlEntities.js";
    import {gsap} from "gsap";
    import {showFullHeader} from "../../lib/stores/InformaAppStore.js";
    import {ScrollTrigger} from "gsap/dist/ScrollTrigger";
    import {beforeNavigate} from "$app/navigation";
    import CookieConsent from "$lib/components/CookieConsent.svelte";


    export let data;
    let showPage = false;
    let tl;

    gsap.registerPlugin(ScrollTrigger);

    onMount(async () => {
        showPage = true;

        tl = gsap.timeline({
            scrollTrigger: {
                trigger: "#header-spacer",
                start: "top 80%",
                toggleActions: "play pause resume reverse",
                onLeave: () => {
                    showFullHeader.set(false);
                },
                onEnterBack: () => {
                    showFullHeader.set(true);
                }
            }
        });
    })

    onDestroy(() => {
        if (tl !== undefined) {
            tl.scrollTrigger.kill();
        }
    })

    // beforeNavigate(async () => {
    //     const headerNavLinks = document.querySelectorAll('.header-nav__link');
    //     headerNavLinks.forEach((link) => {
    //         console.log(link)
    //         link.classList.remove('active');
    //     });
    // });
</script>

    <div class="header-spacer" id="header-spacer"></div>
    <SectionWrappers sectionName="cookie-policy" sectionColor="bg-light-grey">
        <div class="header-spacer"></div>
        <div class="text-component">
            {@html decodeHtmlEntities(data.content.content)}
        </div>
    </SectionWrappers>
    <InformaContctUs data={data.content['contact-us']} />

<style>
    .header-spacer {
        height: 93px;
    }
</style>
